export const brandInfo = {
  name: '幼水若若',
  nameEn: 'Youshui Ruoruo',
  tagline: '以柔克刚，如幼水般温润流淌',
  description: '幼水若若是一个以"水"为灵感的生活方式护肤品牌。我们相信最温柔的力量能够带来最深刻的改变。每一款产品都凝聚着对自然的敬畏和对肌肤的温柔呵护，让护肤回归简单与本真。',
  founded: '2023年',
  location: '中国·杭州',
  philosophy: {
    title: '品牌理念',
    items: [
      {
        title: '柔润滋养',
        description: '如同春日细雨滋润大地，我们以温和的方式渗透肌肤，在不知不觉中改善肤质。',
        icon: 'ri-drop-line',
      },
      {
        title: '纯净本真',
        description: '精选天然植萃成分，摒弃不必要的化学添加，每一款产品都经得起成分的审视。',
        icon: 'ri-leaf-line',
      },
      {
        title: '以柔克刚',
        description: '不追求立竿见影的强效刺激，通过持续的温和呵护，让肌肤从内而外焕发健康光泽。',
        icon: 'ri-heart-line',
      },
      {
        title: '回归自然',
        description: '倡导简约护肤哲学，相信少即是多，让肌肤在自然节奏中找到平衡。',
        icon: 'ri-sun-line',
      },
    ],
  },
  milestones: [
    { year: '2023年春', event: '创始人在云南茶山获得品牌灵感' },
    { year: '2023年秋', event: '幼水若若品牌正式成立，首款产品研发启动' },
    { year: '2024年春', event: '若若系列三款核心产品上市' },
    { year: '2024年秋', event: '幼水系列上市，丰富产品线' },
    { year: '2025年春', event: '首款限定系列发布，获得市场好评' },
    { year: '2025年秋', event: '品牌升级，确立"以柔克刚"核心理念' },
    { year: '2026年', event: '持续创新，致力于将东方护肤智慧传递给更多人' },
  ],
  reputation: [
    {
      id: 'r1',
      name: '林小姐',
      location: '上海',
      rating: 5,
      comment: '用了若若柔肤精华水一个月，皮肤真的变柔嫩了很多。那种润物细无声的感觉，像被温柔对待一样。',
      product: '若若柔肤精华水',
      date: '2026-07-20',
    },
    {
      id: 'r2',
      name: '陈女士',
      location: '杭州',
      rating: 5,
      comment: '润养面霜的质地太棒了！丝绒般细腻，上脸完全不油腻，但保湿力很持久。已经成为我的无限回购款。',
      product: '若若润养面霜',
      date: '2026-07-18',
    },
    {
      id: 'r3',
      name: '张小姐',
      location: '北京',
      rating: 5,
      comment: '幼水轻盈防晒乳真的是我用过最轻薄的防晒！完全不像在涂防晒，像在涂水一样，而且后续上妆也很服帖。',
      product: '幼水轻盈防晒乳',
      date: '2026-07-15',
    },
    {
      id: 'r4',
      name: '王女士',
      location: '深圳',
      rating: 4,
      comment: '氨基酸洁面乳温和又洗得干净，敏感肌用着很安心。希望以后出大瓶装～',
      product: '若若氨基酸洁面乳',
      date: '2026-07-12',
    },
    {
      id: 'r5',
      name: '赵小姐',
      location: '成都',
      rating: 5,
      comment: '保湿面膜太好用了！膜布超薄超服帖，精华液超多，敷完皮肤水嫩嫩的，效果肉眼可见。',
      product: '若若保湿面膜',
      date: '2026-07-08',
    },
    {
      id: 'r6',
      name: '周女士',
      location: '广州',
      rating: 5,
      comment: '极简护肤的理念很打动我，一直在寻找适合自己的简单护肤方案，幼水若若让我找到了方向。',
      product: '幼水修护精华液',
      date: '2026-07-05',
    },
  ],
  contact: {
    email: 'hello@youshuiruoruo.com',
    phone: '400-888-XXXX',
    address: '浙江省杭州市西湖区XX路XX号',
    wechat: 'youshuiruoruo',
    weibo: '@幼水若若',
    xiaohongshu: '幼水若若',
  },
};

export const faqItems = [
  {
    question: '幼水若若的产品适合什么肤质？',
    answer: '幼水若若的产品以温和为核心理念，适合大多数肤质使用。若若系列偏向干性和中性肌肤，幼水系列适合混合性和油性肌肤。但每款产品在上市前都经过了多肤质测试，敏感肌也可以安心使用。建议根据自身肤质特点选择合适的产品。',
  },
  {
    question: '产品开封后可以保存多久？',
    answer: '一般来说，幼水若若的产品在开封后的建议使用期限为6-12个月。具体可以参考产品包装上的"开封后使用期限"标识（像一个打开盖子的罐子图标，里面有数字+M）。建议在期限内使用完毕，以保证产品的最佳效果。',
  },
  {
    question: '孕妇可以使用幼水若若的产品吗？',
    answer: '幼水若若的产品配方温和，不含孕妇慎用成分。但由于孕期肌肤状态特殊，建议在使用前咨询专业医生意见，确保产品适合您当前的肌肤状态。',
  },
  {
    question: '如何选择适合自己的产品？',
    answer: '我们建议从"清洁-水润-防护"三步核心护肤体系出发：首先选择一款温和洁面产品（如氨基酸洁面乳），然后根据自己的肤质选择水润产品（干性肌选润养面霜，油性肌选修护精华液），最后搭配防晒产品进行日间防护。如果您不确定，欢迎联系我们的护肤顾问。',
  },
  {
    question: '产品的退换货政策是怎样的？',
    answer: '收到产品后7天内，如产品未拆封使用，可以联系客服申请退换货。如产品存在质量问题，我们将无条件为您办理退换。具体政策请参考购买渠道的说明。',
  },
  {
    question: '在线下哪里可以购买幼水若若的产品？',
    answer: '目前幼水若若主要通过品牌官方渠道销售。线下已经在杭州、上海、北京、成都等城市的核心商圈设有品牌体验空间，欢迎前来体验。具体地址可通过联系客服获取。',
  },
];